import _objectSpread from '@babel/runtime/helpers/objectSpread2';
import _defineProperty from '@babel/runtime/helpers/defineProperty';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import { getStyleFromAlignment } from '@micromag/core/utils';

var styles = {"inner":"micromag-element-keypad-inner","slot":"micromag-element-keypad-slot"};

var propTypes = {
  align: PropTypes.oneOf(['left', 'right', 'middle']),
  columns: PropTypes.number,
  spacing: PropTypes.number,
  className: PropTypes.string,
  itemClassName: PropTypes.string,
  innerClassName: PropTypes.string,
  items: PropTypes.node
};
var defaultProps = {
  align: null,
  columns: 3,
  spacing: 10,
  className: null,
  itemClassName: null,
  innerClassName: null,
  items: null
};
function Keypad(_ref) {
  var items = _ref.items,
    align = _ref.align,
    columns = _ref.columns,
    spacing = _ref.spacing,
    className = _ref.className,
    itemClassName = _ref.itemClassName,
    innerClassName = _ref.innerClassName;
  var itemWidth = "".concat(100 / columns, "%");
  return /*#__PURE__*/React.createElement("div", {
    className: classNames([styles.container, _defineProperty({}, className, className !== null)])
  }, /*#__PURE__*/React.createElement("div", {
    className: classNames([styles.inner, _defineProperty({}, innerClassName, innerClassName !== null)]),
    style: _objectSpread({}, getStyleFromAlignment({
      horizontal: align
    }))
  }, items !== null ? items.map(function (item) {
    var _ref4 = item || {},
      key = _ref4.key;
    return /*#__PURE__*/React.createElement("div", {
      key: key,
      className: classNames([styles.item, _defineProperty({}, itemClassName, itemClassName !== null)]),
      style: {
        width: itemWidth,
        padding: spacing / 2
      }
    }, item);
  }) : null));
}
Keypad.propTypes = propTypes;
Keypad.defaultProps = defaultProps;

export { Keypad as default };
